import './styles/App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Footer from './components/Footer';
import About from './components/About';
import Portfolio from './components/Portfolio';
import Services from './components/Services';
import Blog from './components/Blog';
import Contact from './components/Contact';
import Career from './components/Career';
import GetAQuote from './components/GetAQuote';
import ScrollToTop from './components/ScrollToTop';
import PortfolioDetails from "./components/PortfolioDetails";
import PageTracker from "./components/PageTracker";
 
const Home = () => {
  return (
    <>
      <Hero />
      <Features />
    </>
  );
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <main className="main-content">
          <PageTracker />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/career" element={<Career />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/project-details" element={<PortfolioDetails />} />
            <Route path="/quote" element={<GetAQuote />} />
            <Route path="/blog/*" element={<Blog />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;